/* GingerMood — chorégraphie scroll (GSAP ScrollTrigger)
   Minimaliste : profondeur et matière, jamais de spectacle. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  var isDesktop = window.matchMedia('(min-width: 990px)').matches;

  /* 1 — Hero : contenu qui remonte, vidéo qui respire */
  var hero = document.querySelector('.gm-hero');
  if (hero) {
    var heroMedia = hero.querySelector('.gm-hero__media');
    var heroContent = hero.querySelector('.gm-hero__content');
    if (heroMedia) {
      gsap.to(heroMedia, {
        yPercent: 12,
        scale: 1.06,
        ease: 'none',
        scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true }
      });
    }
    if (heroContent) {
      gsap.to(heroContent, {
        y: -70,
        opacity: 0.15,
        ease: 'none',
        scrollTrigger: { trigger: hero, start: 'top top', end: '70% top', scrub: true }
      });
    }
  }

  /* 4 — Reveals en cascade */
  function batchReveal(selector) {
    var els = gsap.utils.toArray(selector);
    if (!els.length) return;
    gsap.set(els, { y: 36, opacity: 0 });
    ScrollTrigger.batch(els, {
      start: 'top 88%',
      once: true,
      onEnter: function (batch) {
        gsap.to(batch, { y: 0, opacity: 1, duration: 0.9, stagger: 0.12, ease: 'power3.out', overwrite: true });
      }
    });
  }
  batchReveal('.gm-boire__card');
  batchReveal('.card-wrapper');
  batchReveal('.multicolumn-list__item');
  batchReveal('.gm-val__reveal');
  batchReveal('.gm-slide');
  batchReveal('.gm-map__region');
  batchReveal('.image-with-text__grid');
  batchReveal('.collapsible-content__grid .accordion');

  /* 4b — Valeurs (01→04) : entrée séquentielle liée au scroll,
     chaque item glisse se placer à côté du précédent au fil de la descente */
  var valSeq = gsap.utils.toArray('.gm-val__seq');
  if (valSeq.length) {
    var valGrid = valSeq[0].closest('.gm-val__grid') || valSeq[0].parentNode;
    gsap.set(valSeq, { y: 64, x: isDesktop ? 34 : 0, opacity: 0 });
    var valTl = gsap.timeline({
      scrollTrigger: {
        trigger: valGrid,
        start: 'top 82%',
        end: 'bottom 74%',
        scrub: 0.6
      }
    });
    valSeq.forEach(function (item, i) {
      valTl.to(item, { y: 0, x: 0, opacity: 1, ease: 'power2.out', duration: 1 }, i * 0.7);
    });
  }

  /* Titres de section : remontée douce */
  var titles = gsap.utils.toArray('main h2.h1, main .gm-val__title, main .title');
  titles.forEach(function (el) {
    gsap.set(el, { y: 24, opacity: 0 });
    ScrollTrigger.create({
      trigger: el,
      start: 'top 90%',
      once: true,
      onEnter: function () {
        gsap.to(el, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' });
      }
    });
  });

  /* 5 — (tilt retiré : remplacé par élévation feutrée en CSS — plus premium) */
})();


/* ===== PDP : médias filtrés par format sélectionné ===== */
(function () {
  var GM_DEFAULT_QTY = { '250': 12, '750': 12 };
  var gmLastFmt = null;

  function gmSyncQty(fmt) {
    var input = document.querySelector('quantity-input input[name="quantity"], .quantity__input');
    if (!input) return;
    var def = GM_DEFAULT_QTY[fmt];
    if (!def) return;
    // au chargement ou au changement de format : proposer le minimum (ajustable pour mixer les saveurs)
    if (gmLastFmt !== fmt) {
      input.value = def;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      gmLastFmt = fmt;
    }
  }

  /* garde le format sélectionné quand on change de saveur (les liens saveur pointent vers la variante du même format) */
  function gmSyncFlavorLinks(fmt) {
    document.querySelectorAll('[data-gm-flavor] .gm-flavor__opt').forEach(function (a) {
      var vid = fmt === '750' ? a.getAttribute('data-v750') : a.getAttribute('data-v250');
      var base = (a.getAttribute('href') || '').split('?')[0];
      a.setAttribute('href', vid && vid.length ? base + '?variant=' + vid : base);
    });
  }

  function gmFilterMedia() {
    var checked = document.querySelector('variant-selects input[type="radio"]:checked, .product-form__input input[type="radio"]:checked');
    if (!checked) return;
    var fmt = (checked.value.match(/(\d+)\s*ml/i) || [])[1];
    if (!fmt) return;
    gmSyncQty(fmt);
    gmSyncFlavorLinks(fmt);
    document.querySelectorAll('.product__media-item').forEach(function (li) {
      var img = li.querySelector('img');
      if (!img || img.alt.indexOf('fmt:') === -1) return;
      var show = img.alt.indexOf('fmt:' + fmt) !== -1;
      li.style.display = show ? '' : 'none';
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches('variant-selects input, .product-form__input input')) {
      setTimeout(gmFilterMedia, 50);
    }
  });
  document.addEventListener('DOMContentLoaded', gmFilterMedia);
  gmFilterMedia();
})();
